export default __webpack_public_path__ + "static/media/mobile-selection-check.17842969.svg";